import { render, staticRenderFns } from "./ZBadgeDeliveryMode.vue?vue&type=template&id=1d82f1e9&scoped=true&"
import script from "./ZBadgeDeliveryMode.vue?vue&type=script&lang=js&"
export * from "./ZBadgeDeliveryMode.vue?vue&type=script&lang=js&"
import style0 from "./ZBadgeDeliveryMode.vue?vue&type=style&index=0&id=1d82f1e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d82f1e9",
  null
  
)

export default component.exports